import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fluid":""}},[_c('UnassignedPersonViewer',{attrs:{"showReturnButton":true,"customStyle":'height: 90vh; overflow: auto'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }